import { render, staticRenderFns } from "./PageLeftSideMenu.vue?vue&type=template&id=13258919&scoped=true"
import script from "./PageLeftSideMenu.vue?vue&type=script&lang=js"
export * from "./PageLeftSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PageLeftSideMenu.vue?vue&type=style&index=0&id=13258919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13258919",
  null
  
)

export default component.exports